import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FAQ } from '../utils/constants';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);
  return <section className="bg-gray-50 py-16 px-4" data-id="element-60">
      <div className="max-w-4xl mx-auto" data-id="element-61">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-62">
          Domande Frequenti
        </h2>

        <div className="space-y-4" data-id="element-63">
          {FAQ.map((item, index) => <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-64">
              <button onClick={() => setOpenIndex(openIndex === index ? -1 : index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-65">
                <span className="font-bold text-lg text-gray-900" data-id="element-66">
                  {item.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-gray-600 transition-transform duration-300 flex-shrink-0 ml-4 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-67" />
              </button>
              <AnimatePresence data-id="element-68">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-69">
                    <div className="px-6 pb-4 text-gray-700" data-id="element-70">{item.answer}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}